import { Box, Chip, Typography } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import type { DelayTimelineEvent } from '../types';

interface DelayEventRowProps {
  event: DelayTimelineEvent;
}

function getEventMessage(event: DelayTimelineEvent): string {
  switch (event.event_type) {
    case 'scheduled':
      if (event.scheduled_time) {
        return `Delay set for ${new Date(event.scheduled_time).toLocaleString()}`;
      }
      return 'Delay scheduled';
    case 'fired':
      return 'Delay ended - task ready to work on';
    case 'canceled':
      return 'Delay canceled';
    default:
      return 'Delay event';
  }
}

function getEventChipLabel(eventType: DelayTimelineEvent['event_type']): string {
  switch (eventType) {
    case 'scheduled': return 'Scheduled';
    case 'fired': return 'Ended';
    case 'canceled': return 'Canceled';
    default: return 'Delay';
  }
}

function getEventChipColor(eventType: DelayTimelineEvent['event_type']): 'default' | 'success' | 'warning' | 'error' {
  switch (eventType) {
    case 'scheduled': return 'default';
    case 'fired': return 'warning';
    case 'canceled': return 'default';
    default: return 'default';
  }
}

export function DelayEventRow({ event }: DelayEventRowProps) {
  return (
    <Box
      sx={{
        pl: 2,
        borderLeft: 3,
        borderColor: 'text.disabled',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        <ScheduleIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
        <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500 }}>
          System
        </Typography>
        <Chip
          label={getEventChipLabel(event.event_type)}
          color={getEventChipColor(event.event_type)}
          size="small"
          sx={{ height: 18, fontSize: '0.65rem' }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
          {new Date(event.date).toLocaleString()}
        </Typography>
      </Box>
      <Typography sx={{ mt: 0.5 }} color="text.secondary">
        {getEventMessage(event)}
      </Typography>
    </Box>
  );
}
